import store from "@/redux/store";

import React, { useState } from "react";
import { useParams } from "react-router-dom";

//import {showLoader,hideLoader} from "actions/types";
import { connect } from "react-redux";
import {Overview} from "@/views/TimeRegistration/Overview";
import { alert, info,success, error } from '@/reducers/Modal'
import { LOAD_TIME_REGISTRATIONS } from '@/reducers/TimeRegistration'
import { TenantModel } from "@/models/Tenant";

class TimeRegistrationController extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null, isLoaded: false, secret: null };
  }

    async componentDidMount() {
        const { dispatch } = this.props;
        //if(isLoggedIn && user.id == 0) {
        try {
            await dispatch(LOAD_TIME_REGISTRATIONS()); 
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }            
    //  } 
    }
  
    onSaveHandler = async (data) => {
        const { dispatch } = this.props;


     try {
        await dispatch(addTenant(data)).then((retData) => {
            if(!retData.error) {
                //this.props.navigate("/team/", {"replace": true});
            }
        })
        if(!this.props.error) {
            dispatch( alert({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
        }
      } catch (err) {
        console.error('Failed to save the post: ', err)
      } finally {

      }
        if(!this.props.error) {
            dispatch( success({"header": "Opslaan gegevens", "description": "De gegevens zijn met succes opgeslagen!"}) );
       } 

      
    }
  
  render() {
      const {data, filters} = this.props;
      
      return (
          <Overview {...this.props} key="timereg" data={data} filters={filters} changekey={this.props.changeKey} onSaveHandler={this.onSaveHandler} />
      );
      
  }
}
const TimeRegistrationControllerInit = (props) => {
    const { id } = useParams();
    const {selected} = props;

  return (
    <TimeRegistrationController 
      {...props} 
    />
  );
};

function mapStateToProps(state) {
    const {AuthReducer, UserReducer, TimeRegistrationReducer} = state;
    const {items, filters} = TimeRegistrationReducer;
    const {key} = UserReducer;
    const {error} = UserReducer;
  return {
    error: error,
    changeKey: key,
    data: items,
    filters: filters
    
  };
}

export default connect(mapStateToProps)(TimeRegistrationControllerInit);  